import React from 'react';
import { AtSign, UserRound } from 'lucide-react';

/**
 * À QUI PART CE MAIL — affiché avant l'envoi, jamais deviné.
 *
 * Depuis le 2026-08-30, une privatisation distingue l'entreprise de son référent : quand le référent a une
 * adresse directe, c'est lui qui reçoit la plaquette et le devis (décision d'Emeni). Changer le
 * destinataire sans le dire à l'écran serait le pire des deux mondes — on croirait écrire au standard.
 * Cette ligne le montre noir sur blanc, et signale d'où vient l'adresse.
 *
 * Une adresse manquante n'est pas masquée : c'est justement le cas où il faut réagir avant de cliquer.
 */
export function DestinataireEmail({ email, estReferent }: { email?: string; estReferent?: boolean }) {
    const adresse = (email || '').trim();

    if (!adresse) {
        return (
            <p className="text-[11px] font-semibold text-red-500 flex items-center gap-1.5">
                <AtSign size={12} className="shrink-0" />
                Aucune adresse email sur ce dossier — l'envoi sera refusé.
            </p>
        );
    }

    return (
        <p className="text-[11px] text-content-muted flex items-center gap-1.5 flex-wrap">
            {estReferent ? <UserRound size={12} className="shrink-0" /> : <AtSign size={12} className="shrink-0" />}
            <span>Destinataire : <span className="font-bold text-content">{adresse}</span></span>
            <span className="text-[10px] font-black uppercase tracking-widest px-1.5 py-0.5 rounded bg-surface-soft border border-border">
                {estReferent ? 'Référent' : 'Entreprise'}
            </span>
        </p>
    );
}
